module.exports = __webpack_public_path__ + "media/images/country_flags/sa-298efb09318a6aa1b267ecb0270f3479.png";